class CollectionInfiniteScroll {
  constructor() {
    this.container = document.querySelector('[data-infinite-scroll]');
    this.productGrid = document.querySelector('#product-grid');

    if (!this.container || !this.productGrid) return;

    this.nextLink = this.container.querySelector('[data-infinite-scroll-next]');
    this.loading = false;
    this.prefetchedHTML = null;
    this.prefetchedURL = null;

    if (!this.nextLink) return;

    this.createObserver();
    this.prefetchNextPage();
  }

  createObserver() {
    this.observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          this.loadNextPage();
        }
      },
      {
        root: null,

        // Start loading BEFORE customer reaches bottom.
        // Especially important on mobile.
        rootMargin: '1200px 0px',

        threshold: 0
      }
    );

    this.observer.observe(this.container);
  }

  async prefetchNextPage() {
    if (!this.nextLink || this.loading) return;

    const url = this.nextLink.href;

    // Don't fetch the same page twice
    if (this.prefetchedURL === url && this.prefetchedHTML) return;

    try {
      const response = await fetch(url, {
        credentials: 'same-origin'
      });

      if (!response.ok) return;

      this.prefetchedHTML = await response.text();
      this.prefetchedURL = url;
    } catch (error) {
      console.error('Infinite scroll prefetch error:', error);
    }
  }

  async loadNextPage() {
    if (this.loading || !this.nextLink) return;

    this.loading = true;

    const nextUrl = this.nextLink.href;

    try {
      let html;

      // Use page that was already downloaded in background
      if (
        this.prefetchedHTML &&
        this.prefetchedURL === nextUrl
      ) {
        html = this.prefetchedHTML;
      } else {
        const response = await fetch(nextUrl, {
          credentials: 'same-origin'
        });

        if (!response.ok) {
          throw new Error('Unable to load more products');
        }

        html = await response.text();
      }

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newProductGrid = doc.querySelector('#product-grid');

      if (newProductGrid) {
        const fragment = document.createDocumentFragment();

        [...newProductGrid.children].forEach((product) => {
          fragment.appendChild(product);
        });

        this.productGrid.appendChild(fragment);
      }

      const newInfiniteScroll = doc.querySelector(
        '[data-infinite-scroll]'
      );

      const newNextLink = newInfiniteScroll?.querySelector(
        '[data-infinite-scroll-next]'
      );

      if (newNextLink) {
        this.nextLink.href = newNextLink.href;

        // Clear old preload
        this.prefetchedHTML = null;
        this.prefetchedURL = null;

        // Immediately start downloading following page
        this.prefetchNextPage();
      } else {
        this.observer.disconnect();
        this.container.remove();
        this.nextLink = null;
      }

    } catch (error) {
      console.error('Infinite scroll error:', error);
    } finally {
      this.loading = false;
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new CollectionInfiniteScroll();
});